import apiClient from "./ApiInterceptor";

export const getHighlightSections = async (start_date, end_date) => {
    const params = {};
    if (start_date) params.start_date = start_date;
    if (end_date) params.end_date = end_date;
    const response = await apiClient.get('/highlightSections', { params } );
    return response;
}
